export default "__VITE_ASSET__88de56c9__"